export default __webpack_public_path__ + "static/media/arrow_left.bd9a1f48.svg";